import { bech32, bech32m } from "bech32";
import bs58 from "bs58";
const base58toUint8Array = (base58String) => bs58.decode(base58String);
const uint8ArrayToBase58 = (byteArr) => bs58.encode(byteArr);
const bech32toUint8Array = (address, version) => {
  const lib = [bech32, bech32m][version];
  const { words } = lib.decode(address);
  const uint5Arr = words.slice(1);
  const uint8Arr = new Uint8Array(lib.fromWords(uint5Arr));
  return uint8Arr;
};
const uint8ArrayToBech32 = (byteArr, prefix, version) => {
  const lib = [bech32, bech32m][version];
  const uint5Arr = [version, ...lib.toWords(byteArr)];
  return lib.encode(prefix, uint5Arr);
};
export {
  base58toUint8Array,
  bech32toUint8Array,
  uint8ArrayToBase58,
  uint8ArrayToBech32
};
//# sourceMappingURL=addressEncodingConvertersUtils.js.map